const firebaseConfig = {
  apiKey: "AIzaSyCu-JAKWJju4n-NCfMCz6nkrJTgLGHd-EE",
  authDomain: "doctor-bari-b7ef0.firebaseapp.com",
  projectId: "doctor-bari-b7ef0",
  storageBucket: "doctor-bari-b7ef0.appspot.com",
  messagingSenderId: "326864470354",
  appId: "1:326864470354:web:d717c695d6ce77eec3fa8b",
};
export default firebaseConfig;
